// import React from 'react';
// import CustomTextField from 'components/Fileds/CustomTextFiled';
// import CustomTypography from 'components/Fileds/CustomTypography';
// import * as Yup from 'yup';
// import GenericDialog from '../GenericDialog/GenericDialog';
// import { Box, useTheme } from '@mui/material';
// import CustomAutocomplete from 'components/Fileds/CustomAutocomplete';
// import CustomSelect from 'components/Fileds/CustomSelect';

// const AssignChefSchema = Yup.object().shape({
//   chefId: Yup.number().nullable().required('Please select a chef'),
// });

// const ConformChefModal = ({ open, onClose, initialData, onSubmit, loading, chefOptions = [] }) => {
//   const theme = useTheme();
//   console.log(chefOptions,"chefOptions", initialData,"initialData")
//   // normalize options: ensure { id, name }
//    // normalize options (id + label)
//  const options = chefOptions.map(opt => ({
//   value: opt.id,
//   label: opt.full_name,
// }));

//   return (
//     <GenericDialog
//       open={open}
//       onClose={onClose}
//       title={`Assign Chefs`}
//       initialValues={{
//         station: initialData?.name || '',
//         chefId: initialData?.chefs?.[0]?.id ?? null,
//       }}
//       validationSchema={AssignChefSchema}
//       onSubmit={onSubmit}
//       submitLabel="Assign"
//       loading={loading}
//       requiredFields={['chefId']}
//       enableReinitialize   
//     >
//       {({ values, errors, touched, setFieldValue }) => (
//         <>
//           {/* Station Name - Disabled */}
//           <Box sx={{mb:1}}>
//             <CustomTypography
//               label={`Station "${values.station}" has multiple chefs assigned — please select one chef to take this order item.`}
//             />
//           </Box>
//         {console.log(values,"values in conform chef")}
//           {/* select Chef */}
//           <Box>
//             <CustomTypography
//               label="Assign Chefs"
//               sx={{ fontSize: '14px', fontWeight: 600, color: theme.palette.typographyLabel.main }}
//             />
//             <CustomSelect
//               name="chefId" 
//               options={options}
//               value={options.find(opt => opt?.value == values?.chefId) || null}
//               onChange={(_, newValue) => setFieldValue('chefId', newValue ? newValue.value : null)}
//               placeholder="Select chefs"
//               error={touched.chefId && Boolean(errors.chefId)}
//               helperText={touched.chefId && errors.chefId}
//               getOptionLabel={(option) => option?.label || ""}
//             />
//           </Box>
//         </>
//       )}
//     </GenericDialog>
//   );
// };

// export default ConformChefModal;





import React from 'react';
import CustomTypography from 'components/Fileds/CustomTypography';
import * as Yup from 'yup';
import GenericDialog from '../GenericDialog/GenericDialog';
import { Box, useTheme } from '@mui/material';
import CustomSelect from 'components/Fileds/CustomSelect';

const AssignChefSchema = Yup.object().shape({
  chefId: Yup.number().nullable().required('Please select a chef'),
});

const ConformChefModal = ({
  open,
  onClose,
  initialData,
  onSubmit,
  loading,
  chefOptions = [],
}) => {
  const theme = useTheme();

  // Normalize options (id + label)
  const options = chefOptions.map(opt => ({
    value: opt.id,
    label:
      opt.full_name ||
      opt.name ||
      `${opt.first_name || ''} ${opt.last_name || ''}`.trim() ||
      `Chef #${opt.id}`,
  }));

  return (
    <GenericDialog
      open={open}
      onClose={onClose}
      title="Assign Chefs"
      initialValues={{
        station: initialData?.name || '',
        chefId: initialData?.chefs?.[0]?.id ?? null,
      }}
      validationSchema={AssignChefSchema}
      onSubmit={onSubmit}
      submitLabel="Assign"
      loading={loading}
      requiredFields={['chefId']}
      enableReinitialize
    >
      {({ values, errors, touched, setFieldValue }) => {
        const selectedOption =
          options.find(opt => opt.value === values.chefId) || null;

        return (
          <>
            {/* Station Name */}
            <Box sx={{ mb: 1 }}>
              <CustomTypography
                // label={`Station "${values.station}" has multiple chefs assigned — please select one chef to take this order item.`}
                label={`Multiple chefs are assigned to ${values.station} — please select one to handle this order item.`}
              />
            </Box>


            {/* Select Chef */}
            <Box>
              <CustomTypography
                label="Assign Chef"
                sx={{
                  fontSize: '14px',
                  fontWeight: 600,
                  color: theme.palette.typographyLabel.main,
                }}
              />

              <CustomSelect
                name="chefId"
                options={options}
                value={values?.chefId}
                getOptionLabel={opt => opt?.label || ''}
                // ✅ handle both Select and Autocomplete cases
                onChange={(eventOrValue, newValue) => {
                  if (newValue?.value !== undefined) {
                    // Autocomplete style
                    setFieldValue('chefId', newValue?.value);
                  } else if (eventOrValue?.target) {
                    // Select style
                    setFieldValue('chefId', eventOrValue.target.value);
                  } else {
                    // Fallback
                    setFieldValue('chefId', null);
                  }
                }}
                placeholder="Select chef"
                error={touched.chefId && Boolean(errors.chefId)}
                helperText={touched.chefId && errors.chefId}
              />
            </Box>
          </>
        );
      }}
    </GenericDialog>
  );
};

export default ConformChefModal;
